import cookie from 'react-cookies'
import {COOKIE_NAME_ACCOMMODATION_LIST} from "./AccommodationConstant.ts"

export const SaveOnCookie = {

  saveList(items:string){
    cookie.save(COOKIE_NAME_ACCOMMODATION_LIST, items, { path: '/' })
  },
}
